angular.module('picmonic-common').filter('HTMLBreakline', [
  '$sce',
  function ($sce) {
    return function (input) {
      if (input) {
        return $sce.trustAsHtml(input.replace(/(?:\r\n|\r|\n)/g, '<br />'));
      }
    };
  },
]);
